module.exports = __webpack_public_path__ + "static/HM100K-8dd5ed95143391b869df11235e9f6b80.svg";